module.exports = __webpack_public_path__ + "static/background-breed-225e3016672b413232d501498e16a716.png";